import { storefrontInventoryServicesHttpClient } from '../../utils/HttpClient'

import { setInventoryInSessionStorage } from './inventory.sessionStorage'
export interface InventoryResponce {
  available: number
  locationId: number
  inventoryType: string
  tags: {
    preOrderShippingDate: string
  } | null
  vendorCode: string
  isInventoryPresentAtSFWarehouse?: boolean
}

interface GetInventoryOptions {
  storeResultInStorage?: boolean
  [key: string]: any
}

export async function getInventory({ storeResultInStorage = false, ...params }: GetInventoryOptions) {
  try {
    const { data } = await storefrontInventoryServicesHttpClient.get('/active-inventory', {
      params,
    })
    if (storeResultInStorage) {
      setInventoryInSessionStorage(data)
    }
    return data
  } catch (e: any) {
    console.error('Failed while fetching getInventory(), API - `/carts/${cartId}`', e)
    if (storeResultInStorage) {
      setInventoryInSessionStorage(e)
    }
    if (e?.toString() === 'AxiosError: Network Error' && e?.code === 'ERR_NETWORK') return { isCorsError: true }
    return {}
  }
}
